<h1>{{ "common.pagenotfound.header" | fms }}</h1>

<section class="mt-48">
  <img alt [src]="'common.pagenotfound.imageRebrand' | fms" />
</section>
<section class="mt-32">
  <a routerLink="/">
    <button [stbButton]="'primary'" [setIconBefore]="true" [iconType]="'arrow_left'" [rebrand]="true">
      {{ "common.pagenotfound.backButtonLabel" | fms }}
    </button>
  </a>
</section>
